import Templates from '../../../store/templates/main';

angular
    .module('festzelt-os.modules.templates')
    .factory('Templates', [
        '$injector',
        'Template',
        ($injector, Template) => new Templates(Template, {
            injector: $injector
        })
    ]);




// WEBPACK FOOTER //
// ./src/app/modules/templates/store/templates.js